export default __webpack_public_path__ + "static/media/gallery_03.ac11e790.jpg";